import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { scrollToId } from "@/components/landing/Reveal";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import WhyEclick from "@/components/landing/WhyEclick";
import Capabilities from "@/components/landing/Capabilities";
import Categories from "@/components/landing/Categories";
import Brands from "@/components/landing/Brands";
import Solutions from "@/components/landing/Solutions";
import Sectors from "@/components/landing/Sectors";
import Process from "@/components/landing/Process";
import Expectations from "@/components/landing/Expectations";
import SuccessCases from "@/components/landing/SuccessCases";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import TerminosPage from "@/components/landing/TerminosPage";
import PrivacidadPage from "@/components/landing/PrivacidadPage";

const Home = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) setTimeout(() => scrollToId(hash.slice(1)), 500);
  }, []);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhyEclick />
        <Capabilities />
        <Categories />
        <Brands />
        <Solutions />
        <Sectors />
        <Process />
        <Expectations />
        <SuccessCases />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-white text-ecdeep antialiased">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terminos-y-condiciones" element={<TerminosPage />} />
          <Route path="/aviso-de-privacidad" element={<PrivacidadPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
